import { BillIcon } from '../../../icons';
import { formatRecurringType, getAverageAmountLabel } from '../../../utils/recurring';
import SlideoutMenu from '../../base/SlideoutMenu';

import type { RecurringTransactionType } from '../../../__generated__/globalTypes';

interface IRecurringTypeRowProps {
  type: RecurringTransactionType | null | undefined;
  /** When provided, displays a "Typically $X" annotation alongside the type. */
  amountRange?: string[];
}

const RecurringTypeRow = ({ type, amountRange }: IRecurringTypeRowProps) => {
  if (!type) {
    return null;
  }

  return (
    <SlideoutMenu.Row icon={<BillIcon className="size-4.5 shrink-0" />} title="Type">
      <div className="flex flex-col items-end">
        <div className="text-primary text-md truncate font-medium">{formatRecurringType(type)}</div>
        {amountRange && (
          <div className="text-tertiary text-sm font-normal italic">
            Typically {getAverageAmountLabel(amountRange, { abbreviated: false })}
          </div>
        )}
      </div>
    </SlideoutMenu.Row>
  );
};

export default RecurringTypeRow;
